let config = {
  api: {
    version: "",
    jwt: "",
    baseUrl: ""
  },
};

export { config };
